import React from 'react';
import OfferingCard from '../components/OfferingCard';

/**
 * Shared hub layout for any collection of offerings — dialysis centres, casket
 * packages, ways to give. Cards use exactly the same shape as the Learn and
 * Volunteer thumbnails so every grid in the app reads consistently.
 */
export default function OfferingHub({
  testId,
  heading,
  heroTitle,
  heroSubtitle,
  heroImage,
  heroColor = '#0F9488',
  items,
  savedIds,
  onToggleSave,
  onSelect,
  footnote
}) {
  return (
    <div data-testid={testId}>
      <div className="p-4 desktop-shell md:pt-6">
        <div
          className="relative rounded-2xl overflow-hidden h-[150px] md:h-[220px]"
          data-testid={`${testId}-hero`}
          style={{ backgroundColor: heroColor }}
        >
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-[55%] pl-5 md:pl-10 z-10">
              <h2 className="text-2xl md:text-3xl font-extrabold text-white leading-tight">{heroTitle}</h2>
              <p className="text-xs md:text-base text-white/80 mt-1.5 md:mt-2.5 leading-snug">{heroSubtitle}</p>
            </div>
            {heroImage && (
              <img
                src={heroImage}
                alt=""
                className="absolute right-0 bottom-0 h-full w-[55%] object-cover object-center"
              />
            )}
          </div>
        </div>
      </div>

      <div className="px-4 pb-6 desktop-shell">
        <h2 className="text-base md:text-lg font-bold text-[#0F172A] mb-3">{heading}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {items.map((item) => (
            <OfferingCard
              key={item.id}
              item={item}
              isSaved={savedIds?.has(item.id)}
              onToggleSave={onToggleSave}
              onClick={() => onSelect(item)}
            />
          ))}
        </div>
        {footnote && (
          <p className="mt-4 text-[11px] md:text-xs leading-snug text-muted-foreground">{footnote}</p>
        )}
      </div>
    </div>
  );
}
